<p>Find school by programme name (beta)</p>
<input class="programme-name-input" [(ngModel)]="selectedProgramme">
<button (click)="findSchools()">Search</button>
<div *ngIf="searchStart">
    <div *ngIf="!loading && schools.length == 0">
        No result found
    </div>
    <div *ngIf="!loading && schools.length > 0">
        School for this programme can be:
        <div *ngFor="let school of schools">
            <span>ID: {{school.id}} | Name: {{school.name}}</span>
        </div>
    </div>
</div>